
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hide-closest-modal"
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.onClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick)
  }

  onClick(event) {
    this.closest('.js-contact-modal').classList.remove('--show')
  }
}